import { AlertTriangle, RefreshCw } from 'lucide-react'

const ErrorMessage = ({ message, onRetry, showRetry = true, className = '' }) => {
  return (
    <div className={`card bg-red-50 border-red-200 ${className}`}>
      <div className="flex items-start space-x-3">
        <AlertTriangle className="h-6 w-6 text-red-500 flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-medium text-red-800">
            Błąd ładowania danych
          </h3>
          <p className="text-sm text-red-700 mt-1 break-words">
            {message || 'Nie udało się załadować danych. Sprawdź połączenie z serwerem.'}
          </p>
          {onRetry && showRetry && (
            <button
              onClick={onRetry}
              className="mt-3 inline-flex items-center space-x-2 bg-red-100 text-red-800 px-3 py-2 rounded-md text-sm font-medium hover:bg-red-200 transition-colors focus:outline-none focus:ring-2 focus:ring-red-500"
            >
              <RefreshCw className="h-4 w-4" />
              <span>Spróbuj ponownie</span>
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default ErrorMessage
